import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';
import React, { useEffect, useState } from 'react';
import toastr from 'toastr';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Label,
  Row,
  Input,
} from 'reactstrap';
import useAttachement from '../../helpers/hooks/useAttachments';
import usePost from '../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import Select from 'react-select';
import usePatch from '../../helpers/hooks/usePatch';
import useGetAuthed from '../../helpers/hooks/useGetAuthed';

const ProductDetails = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [product, , productLoading] = useGet(
    `/khareedari-products/${id}?filter[include][0][relation]=company&filter[include][1][relation]=khareedariCategory`,
    true
  );
  const [selectedImage, setSelectedImage] = useState();
  const [categories, , categoriesLoading] = useGetAuthed(
    '/khareedari-categories',
    true
  );
  const [districts, , districtssLoading] = useGet('/districts', true);
  const [companies, , companiesLoading] = useGet('/companies', true);
  const [postProduct, postedData, postingError, dataPosting] = usePatch(
    `/khareedari-products/${id}`
  );
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedDistricts, setSelectedDistricts] = useState();
  const { upload, error, loading: imagesUploading, urls } = useAttachement();

  const handleSubmit = (event, errors, values) => {
    if (dataPosting) {
      return;
    }
    if (errors.length > 0 || !selectedCategory || !selectedCompany) {
      return toastr.warning('Please fix errors in the form');
    }
    const obj = {
      ...values,
      price: parseFloat(values.price),
      khareedariCategoryId: selectedCategory.value,
      companyId: selectedCompany.value,
    };
    if (selectedImage) {
      upload([selectedImage]).then((_urls) => {
        postProduct({ ...obj, image: _urls[0] });
      });
    } else {
      postProduct(obj);
    }
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Product has been updated successfully');
      history.push('/supplies/products');
    }
  }, [history, postedData]);
  useEffect(() => {
    if (product) {
      setSelectedCategory({
        value: product.khareedariCategory.id,
        label: product.khareedariCategory.name,
      });
      setSelectedCompany({
        value: product.company.id,
        label: product.company.name,
      });
      // setSelectedDistricts(
      //   product.districts?.map((x) => ({
      //     value: x.id,
      //     label: x.name,
      //   }))
      // );
    }
  }, [product]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Add New Product</h4>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>Name</Label>
                      <AvField
                        name='name'
                        value={product?.name}
                        placeholder='Name'
                        type='text'
                        errorMessage='Enter Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='name'
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor='name'>Description</Label>
                      <AvField
                        name='description'
                        placeholder='Description'
                        type='text'
                        value={product?.description}
                        errorMessage='Enter Description'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='description'
                      />
                    </FormGroup>
                    <Row className='mb-3'>
                      <Col md={1}>
                        <img
                          src={product?.image}
                          className='rounded-circle avatar-sm card-img'
                          alt="product-img"
                        />
                      </Col>
                      <Col md={11}>
                        {' '}
                        <FormGroup>
                          <div className='custom-file'>
                            <CustomInput
                              type='file'
                              className='custom-file-input'
                              id='image'
                              accept='image/*'
                              onChange={(e) => {
                                setSelectedImage(e.target.files[0]);
                              }}
                            />
                            <Label
                              className='custom-file-label'
                              htmlFor='image'
                            >
                              {selectedImage
                                ? selectedImage.name
                                : 'Change Image'}
                            </Label>
                          </div>
                          {selectedImage && (
                            <span className='d-block font-size-20 text-danger text-right'>
                              <i
                                onClick={() => setSelectedImage(null)}
                                style={{ cursor: 'pointer' }}
                                className='ri-close-line'
                              ></i>
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label htmlFor='name'>Price</Label>
                          <AvField
                            name='price'
                            placeholder='Price'
                            type='number'
                            value={product?.price}
                            errorMessage='Enter Price'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='price'
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label htmlFor='name'>Selling Unit</Label>
                          <AvField
                            name='unit'
                            placeholder='Selling Unit'
                            type='text'
                            value={product?.unit}
                            errorMessage='Enter Unit'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='unit'
                          />
                        </FormGroup>
                      </Col>
                      <Col className=''>
                        <FormGroup>
                          <Label htmlFor='name'>Weight/Qty</Label>
                          <AvField
                            name='weight'
                            placeholder='Weight/Qty'
                            type='text'
                            value={product?.weight}
                            errorMessage='Enter Weight'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='weight'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label htmlFor='name'>Representative's Phone Number</Label>
                          <AvField
                            name='repPhone'
                            placeholder="Phone Number (923xxxxxxxxxx)"
                            type='text'
                            value={product?.repPhone}
                            errorMessage='Please enter the phone number of the representative.'
                            className='form-control'
                            validate={{ 
                              required: { value: true },
                              pattern: { value: '^923' },
                              minLength: { value: 12 },
                              maxLength: { value: 12 }
                            }}
                            id='repPhone'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <AvInput
                        tag={CustomInput}
                        type='checkbox'
                        checked={product?.showInAd}
                        label='Show in Ad'
                        name='showInAd'
                        validate={{ required: { value: false } }}
                      />
                    </FormGroup>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Category</Label>
                          <Select
                            isLoading={categoriesLoading}
                            value={selectedCategory}
                            closeMenuOnSelect={true}
                            onChange={(e) => setSelectedCategory(e)}
                            options={
                              categories &&
                              categories.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Company</Label>
                          <Select
                            isLoading={companiesLoading}
                            value={selectedCompany}
                            closeMenuOnSelect={true}
                            onChange={(e) => setSelectedCompany(e)}
                            options={
                              companies &&
                              companies.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <Label>Distrcits</Label>
                      <AvField
                        type='select'
                        name='districtIds'
                        value={product?.districtIds}
                        multiple
                        validate={{ required: true }}
                      >
                        {districts?.map((x) => (
                          <option value={x.id}>{x.name}</option>
                        ))}
                      </AvField>
                    </FormGroup>
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Save Product'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};
export default ProductDetails;
